import * as React from "react";
import EditFault from "../../Editing/EditFault";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setFaultExtraProperties, getGroupNameByDomainId } from "../../../utils/pdApiUtils";
import { escalatorFaultVersionFilter } from "../../../utils/utils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type EscalatorFaultsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingEscalatorFaults: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.EscalatorSubmenu;
  filterOptions: State.FilterOptions;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.EscalatorSubmenu, columnFilter: Filter[]) => void;
};

type EscalatorFaultsTableState = {
  isModalOpen: boolean;
};

export class EscalatorFaultsTable extends React.Component<
  EscalatorFaultsTableProps,
  EscalatorFaultsTableState
> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount():void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
    if (this.props.pdApi.escalatorDataActCodes === undefined) {
      this.props.pdApiActions.fetchEscalatorDataActCodes();
    }
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element{
    const { columns, pdApi, mainState, isEditActive, toggleModal, filterOptions, isLoadingEscalatorFaults } = this.props;
    const { escalatorFaults } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let escalatorFaultRows: Api.EscalatorFault[] = [];
    let selectedColumns: State.Column[] = [];

    escalatorFaultRows = escalatorFaults.filter(
      fault => getGroupNameByDomainId(fault.domain.id, pdApi) === "Escalator"
    );
    escalatorFaultRows = escalatorFaultVersionFilter(escalatorFaultRows, filterOptions.selectedEscalatorVersion);
    escalatorFaultRows = escalatorFaultRows.map(row => setFaultExtraProperties(row, pdApi)) as Api.EscalatorFault[];
    selectedColumns = columns["Escalator Faults"];
    const startingPage = mainState.lastEditedObjectId
      ? (escalatorFaultRows.findIndex(fault => fault.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={escalatorFaultRows}
            loading={isLoadingEscalatorFaults}
            loadingText="Fetching escalator faults..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isFaultSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view dimmer page" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditFault toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /**
   * Returns status if fault has been selected
   * @param {Api.Fault} fault
   * @returns {boolean}
   */
  private isFaultSelected = (fault: Api.EscalatorFault): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && fault.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default EscalatorFaultsTable;
